import { HttpRoutes } from 'utils/constant';

import { addUserGroupToData,format } from '../utils';

import Service from './service';

const fetchSurveyById = (id) => {
  const url = format(HttpRoutes.fetchSurveyById, { id });
  return Service.get(url)
    .then((response) => response.data)
    .catch((error) => new Error(error.toString()));
};


export const surveyLogActivity = (surveyResponse) => {
  const data = {
    origin: 'Survey Questions',
    surveyStep: surveyResponse.surveyStep ? `${surveyResponse.surveyStep}` : '',
    questionId: surveyResponse.questionId,
    surveyID: surveyResponse.surveyId,
    answer: Array.isArray(surveyResponse.answer)
      ? surveyResponse.answer
      : surveyResponse.answer
      ? [surveyResponse.answer]
      : [],
    surveyName: surveyResponse.surveyName,
    surveyFlow: surveyResponse.surveyFlow,
    userGroup: {},
    activityType: 'SURVEY_ACTIVITY',
    referer: document.referrer,
    url: location.href,
    pageCategory: window.pageCategory ? window.pageCategory : '',
  };
  if (!data.referer) {
    data.referer = window.location.href.split('?')[0];
  }
  addUserGroupToData(data);
  return Service.post(HttpRoutes.logActivity, data);
};

/**
 * Survey Response structure.
 * @param {Object} surveyResponse - payload info for survey response.
 * @param {Array} surveyResponse.answer: []
 * @param {String} surveyResponse.questionId - question ID
 * @param {String} surveyResponse.surveyFlow - "surveyPopup"
 * @param {String} surveyResponse.surveyId - : surveyId
 * @param {String} surveyResponse.surveyName - : survey name
 * @param {Date} surveyResponse.surveyStartTimeStamp - : time stamp
 * @param {String} surveyResponse.surveyStep - : surveyStep
 * @param {number} surveyResponse.timeStamp - : time stamp
 * @param {String} surveyResponse.utm_campaign - : campaign
 */

const sendSurveyResponse = (surveyResponse) => {
  surveyLogActivity(surveyResponse);
  return Service.post(HttpRoutes.surveyResponse, surveyResponse)
    .then((response) => {
      const {
        data: { status },
      } = response;
      if (status === 'SUCCESS') {
        return true;
      }
    })
    .catch((error) => console.error('sendSurveyResponse error', error));
};

const sendCompanyReview = (payload) =>
  Service.post(HttpRoutes.reviewResponse, payload)
    .then((response) => response.data)
    .catch((error) => {
      console.error('sendCompanyReview catch error', error);
    });

export const surveyService = {
  fetchSurveyById,
  sendSurveyResponse,
  sendCompanyReview,
};
